export default __webpack_public_path__ + "static/media/riku_completed_i_think_idefk_anymore.761b2748.mp3";